import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import ADMIN_NAV_GROUPS from './adminNavConfig';
import './AdminLayout.css';

const AdminSidebar = ({ selectedSection, onSelectSection, collapsed, onToggleCollapsed, badges = {} }) => {
    return (
        <aside className={`admin-sidebar ${collapsed ? 'admin-sidebar--collapsed' : ''}`}>
            <div className="admin-sidebar__header">
                <div className="admin-sidebar__brand">
                    <span className="admin-sidebar__brand-mark">CM</span>
                    {!collapsed && <span className="admin-sidebar__brand-text">Admin</span>}
                </div>
                <button
                    type="button"
                    className="admin-sidebar__collapse-btn"
                    onClick={onToggleCollapsed}
                    title={collapsed ? 'Expandir menú' : 'Colapsar menú'}
                    aria-label={collapsed ? 'Expandir menú' : 'Colapsar menú'}
                >
                    {collapsed ? <ChevronRight size={16} /> : <ChevronLeft size={16} />}
                </button>
            </div>

            <nav className="admin-sidebar__nav" aria-label="Navegación principal">
                {ADMIN_NAV_GROUPS.map((group) => (
                    <div
                        key={group.id}
                        className={`admin-sidebar__group ${group.muted ? 'admin-sidebar__group--muted' : ''}`}
                    >
                        {!collapsed && (
                            <div className="admin-sidebar__group-label">{group.label}</div>
                        )}
                        <ul className="admin-sidebar__list">
                            {group.items.map((item) => {
                                const Icon = item.icon;
                                const isActive = selectedSection === item.key;
                                const badge = badges[item.key];
                                return (
                                    <li key={item.key}>
                                        <button
                                            type="button"
                                            className={`admin-sidebar__item ${isActive ? 'admin-sidebar__item--active' : ''}`}
                                            onClick={() => onSelectSection(item.key)}
                                            title={collapsed ? item.label : undefined}
                                            aria-current={isActive ? 'page' : undefined}
                                        >
                                            <span className="admin-sidebar__item-icon">
                                                <Icon size={18} />
                                            </span>
                                            {!collapsed && (
                                                <span className="admin-sidebar__item-label">{item.label}</span>
                                            )}
                                            {!collapsed && badge != null && badge > 0 && (
                                                <span className="admin-sidebar__item-badge">{badge}</span>
                                            )}
                                            {collapsed && badge != null && badge > 0 && (
                                                <span className="admin-sidebar__item-badge admin-sidebar__item-badge--dot" aria-label={`${badge} pendientes`} />
                                            )}
                                        </button>
                                    </li>
                                );
                            })}
                        </ul>
                    </div>
                ))}
            </nav>
        </aside>
    );
};

export default AdminSidebar;
